/* eslint-disable no-undef */
import api from "./ApiService";

const getStatus = () => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/statuses`)
    .then((response: any) => {
      return response;
    });
};

const StatusServices = {
  getStatus,
};
export default StatusServices;
